import { gsap } from "gsap"

/**
 * SiteSwitcher functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class SiteSwitcher {
  /**
   * Constructs a new PageIntroduction instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.link = this.element.querySelector('a')

    // // MakeWorkshop Timeline
    const mwTimeline = gsap.timeline({repeat: 0, repeatDelay: 0, paused:true})
    mwTimeline.to("[data-component='mw-transition']", {duration: 1, x: 0, y: 0, ease: "expo.out"});
    mwTimeline.to("[data-component='mw-transition'] svg", {duration: 0.8, opacity: 1}, "+=0.5");
    mwTimeline.to("[data-component='mw-transition'] #rotate", {rotation: 180, transformOrigin: '50% 31px', ease: "expo.out", duration: 1.5}, "+=0.5");


    this.link.addEventListener('click', event => {
      event.preventDefault()
      if (document.body.classList.contains('make-workshop')) {
        mmTimeline.play()
      } else {
        mwTimeline.play()
      }
    })

  }
}



// WEBPACK FOOTER //
// ./components/site-switcher/index.js